/** @param {number} digits */
export function ratioOrNull(value, digits) {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return null;
  }
  return value.toFixed(digits);
}

export function minutesFromMs(ms) {
  if (typeof ms !== 'number' || !Number.isFinite(ms)) {
    return null;
  }
  return Math.round(ms / (60 * 1000));
}

function finiteNumberFromRecordField(value) {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

function lagMinutesFromFirestoreMs(lagMsUnknown) {
  return typeof lagMsUnknown === 'number' && Number.isFinite(lagMsUnknown)
    ? minutesFromMs(lagMsUnknown)
    : null;
}

/** @param {Record<string, unknown>} dataRecord */
function resolveComputedAtMillis(dataRecord) {
  const explicitMillis = dataRecord.computedAtMillis;
  if (typeof explicitMillis === 'number' && Number.isFinite(explicitMillis)) {
    return explicitMillis;
  }
  const computedTs = dataRecord.computedAt;
  if (!computedTs || typeof computedTs.toMillis !== 'function') {
    return null;
  }
  const millisFromTimestamp = computedTs.toMillis();
  return Number.isFinite(millisFromTimestamp) ? millisFromTimestamp : null;
}

/** @param {Record<string, unknown>} dataRecord */
export function mapFirestoreSloPayload(dataRecord) {
  if (!dataRecord || typeof dataRecord !== 'object') {
    return null;
  }

  const computedAtMillisResolved = resolveComputedAtMillis(dataRecord);
  const meanLagMs = dataRecord.dispatchLagMeanEstimateMs;
  const p95LagMs = dataRecord.dispatchLagP95EstimateMs;
  const p99LagMs = dataRecord.dispatchLagP99EstimateMs;

  return {
    computedAtMillis: Number.isFinite(computedAtMillisResolved) ? computedAtMillisResolved : null,
    rollupWindowHours: finiteNumberFromRecordField(dataRecord.rollupWindowHours),
    rollupDispatcherRunsLoaded: finiteNumberFromRecordField(dataRecord.rollupDispatcherRunsLoaded),
    dispatchLagMergedSampleCount: finiteNumberFromRecordField(dataRecord.dispatchLagMergedSampleCount),
    dispatchLagMeanEstimateMinutes: lagMinutesFromFirestoreMs(meanLagMs),
    dispatchLagP95EstimateMinutes: lagMinutesFromFirestoreMs(p95LagMs),
    dispatchLagP99EstimateMinutes: lagMinutesFromFirestoreMs(p99LagMs),
    activeScheduleCount: finiteNumberFromRecordField(dataRecord.activeScheduleCount),
    pausedScheduleCount: finiteNumberFromRecordField(dataRecord.pausedScheduleCount),
    errorSuppressedScheduleCount: finiteNumberFromRecordField(dataRecord.errorSuppressedScheduleCount),
    overdueBeyond24hActiveCount: finiteNumberFromRecordField(dataRecord.overdueBeyond24hActiveCount),
    overdueBacklogRatioLabel: ratioOrNull(dataRecord.overdueBacklogRatio, 4),
    sloBreachLagWarningP95: dataRecord.sloBreachLagWarningP95 === true,
    sloBreachLagCriticalP99: dataRecord.sloBreachLagCriticalP99 === true,
    sloBreachOverdueWarning: dataRecord.sloBreachOverdueWarning === true,
    sloBreachOverdueCritical: dataRecord.sloBreachOverdueCritical === true,
    schedulerSloLagP95BreachesConsecutiveStored: finiteNumberFromRecordField(
      dataRecord.schedulerSloLagP95BreachesConsecutiveStored,
    ),
  };
}
